//导入插件
import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import {
	Message
} from 'element-ui'


const Login = () => import("@/views/Login.vue"); // 登录
const Home = () => import("@/views/Home.vue"); // 首页
const FirstPage = () => import("@/views/child/FirstPage.vue"); // 客户未完成工单
const chaoqipaihangchaxun = () => import("@/views/child/chaoqipaihangchaxun.vue"); // 客服超期查询
const lschaoqipaihangchaxun = () => import("@/views/child/lschaoqipaihangchaxun.vue"); // 历史客服超期查询

const khdclgd = () => import("@/views/child/khdclgd.vue"); // 客户未完成工单
// const AssessFirstPage = () => import("@/views/child/AssessFirstPage.vue"); // 考核任务查询
const weijiekongdan = () => import("@/views/child/weijiekongdan.vue"); // 工单公海
const liuyan = () => import("@/views/child/liuyan.vue"); // 留言
const kefuyiwanchenggongdan = () => import("@/views/child/kefuyiwanchenggongdan.vue"); // 客服已完成工单
const gongdanxiangqing = () => import("@/views/child/gongdanxiangqing.vue"); // 项目模版
const xinjiangongdan = () => import("@/views/child/xinjiangongdan.vue"); // 新建工单
const kehuzhuce = () => import("@/views/child/kehuzhuce.vue"); // 客户注册
const feikehuzhuce = () => import("@/views/child/feikehuzhuce.vue"); // 客服注册
const kehuchaxun = () => import("@/views/child/kehuchaxun.vue"); // 客户查询
const kefuchaxun = () => import("@/views/child/kefuchaxun.vue"); // 客服查询
const kehuziliaoweihu = () => import("@/views/child/kehuziliaoweihu.vue"); // 客户资料维护
const kehuziliaoChaXun = () => import("@/views/child/kehuziliaoChaXun.vue"); // 客户资料查询
const quanxianfenpei = () => import("@/views/child/quanxianfenpei.vue"); // 权限分配
const quanbugongdanchaxun = () => import("@/views/child/quanbugongdanchaxun.vue"); // 全部工单查询
const XiaBanHouGD = () => import("@/views/child/XiaBanHouGD.vue"); // 下班后工单
const quanbugongdanxq = () => import("@/views/child/quanbugongdanxq.vue"); // 全部工单详情
const xiugaizhanghaoxinxi = () => import("@/views/child/xiugaizhanghaoxinxi.vue"); // 全部工单详情
const statistical = () => import("@/views/child/statistical.vue"); // 客服处理工单统计
const WJDC = () => import("@/views/child/WJDC.vue"); // 问卷调查

const xiugaikehuzhanghaoxinxi = () => import("@/views/child/xiugaikehuzhanghaoxinxi.vue"); // 全部工单详情

const quanxianweihu = () => import("@/views/child/quanxianweihu.vue"); //权限维护

const quanxianxinzeng = () => import("@/views/child/quanxianxinzeng.vue"); //权限新增
const chaxunquanxian = () => import("@/views/child/chaxunquanxian.vue"); //查询权限

const customerRanking = () => import("@/views/child/customerRanking.vue"); //客户排行
const kefuyijiegongdan = () => import("@/views/child/kefuyijiegongdan.vue"); //客服已接工单
const kehuyiwanchenggongdan = () => import("@/views/child/kehuyiwanchenggongdan.vue"); // 客户已完成工单
const zidianweihu = () => import("@/views/child/zidianweihu.vue"); // 字典查询
const zidianxinzeng = () => import("@/views/child/zidianxinzeng.vue"); // 字段新增
const zidianxiugai = () => import("@/views/child/zidianxiugai.vue"); // 字典修改
const kehuxinjiangongdan = () => import("@/views/child/kehuxinjiangongdan.vue"); // 客户新建工单

const khquanbugongdanxq = () => import("@/views/child/khquanbugongdanxq.vue"); // 客户全部工单详情

const kehugongdanxiangqing = () => import("@/views/child/kehugongdanxiangqing.vue"); // 客户工单详情
const khquanbugongdanchaxun = () => import("@/views/child/khquanbugongdanchaxun.vue"); // 客户查询全部工单
const tuisong = () => import("@/views/child/tuisong.vue"); // 推送
const kefuyipingjiagongdan = () => import("@/views/child/kefuyipingjiagongdan.vue"); // 客服已评价工单

const shangchuanshipin = () => import("@/views/child/shangchuanshipin.vue"); // 客服已评价工单
const kefuzhanwei = () => import("@/views/child/kefuzhanwei.vue"); // 客服占位
const mobanchaxun = () => import("@/views/shishishenqing/moban/mobanchaxun.vue"); // 模版查询
const mobanchakan = () => import("@/views/shishishenqing/moban/mobanchakan.vue"); // 模版查看

const kehuzhanwei = () => import("@/views/child/kehuzhanwei.vue"); // 模版查询

const shishishenqing = () => import("@/views/shishishenqing/shenqing/shishishenqing.vue"); // 实施申请
const shishishenqingtianjia = () => import("@/views/shishishenqing/shenqing/shishishenqingtianjia.vue"); // 实施申请添加
const canyusssqlb = () => import("@/views/shishishenqing/shenqing/canyusssqlb.vue"); // 参与实施申请列表
const faqisssqlb = () => import("@/views/shishishenqing/shenqing/faqisssqlb.vue"); // 发起实施申请列表
const qubusssqlb = () => import("@/views/shishishenqing/shenqing/qubusssqlb.vue"); // 全部实施申请列表
const shishishenqingxq = () => import("@/views/shishishenqing/shenqing/shishishenqingxq.vue"); // 实施申请查看
const shishishenqingbianji = () => import("@/views/shishishenqing/shenqing/shishishenqingbianji.vue"); // 实施申请编辑

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err);
}


//注册到vue
Vue.use(VueRouter)

const routes = [{
	path: "/",
	redirect: "/login"
}, {
	path: "/login",
	name: "login",
	component: Login,
	meta: {
		title: "登录"
	}
}, {
	path: "/home",
	component: Home,
	redirect: "/home/kefuzhanwei",
	children: [

		{
			path: "kefuzhanwei",
			name: "kefuzhanwei",
			component: kefuzhanwei,
			meta: {
				title: "首页"
			}
		}, {
			path: "firstPage",
			name: "firstPage",
			component: FirstPage,
			meta: {
				title: "未完成工单"
			}
		}, {
			path: "khdclgd",
			name: "khdclgd",
			component: khdclgd,
			meta: {
				title: "待评价工单"
			}
		},
		{
			path: "chaoqipaihangchaxun",
			name: "chaoqipaihangchaxun",
			component: chaoqipaihangchaxun,
			meta: {
				title: "超期工单查询"
			}
		},
		{
			path: "lschaoqipaihangchaxun",
			name: "lschaoqipaihangchaxun",
			component: lschaoqipaihangchaxun,
			meta: {
				title: "历史超期工单查询"
			}
		},
		
		{
			path: "weijiekongdan",
			name: "weijiekongdan",
			component: weijiekongdan,
			meta: {
				title: "未接工单"
			}
		},
		{
			path: "kefuyiwanchenggongdan",
			name: "kefuyiwanchenggongdan",
			component: kefuyiwanchenggongdan,
			meta: {
				title: "已完成工单"
			}
		},
		{
			path: "gongdanxiangqing",
			name: "gongdanxiangqing",
			component: gongdanxiangqing,
			meta: {
				title: "工单详情"
			}
		},
		{
			path: "xinjiangongdan",
			name: "xinjiangongdan",
			component: xinjiangongdan,
			meta: {
				title: "新建工单"
			}
		},
		{
			path: "kehuzhuce",
			name: "kehuzhuce",
			component: kehuzhuce,
			meta: {
				title: "客户注册"
			}
		},
		{
			path: "feikehuzhuce",
			name: "feikehuzhuce",
			component: feikehuzhuce,
			meta: {
				title: "非客户注册"
			}
		},
		{
			path: "kehuchaxun",
			name: "kehuchaxun",
			component: kehuchaxun,
			meta: {
				title: "客户查询"
			}
		},
		{
			path: "kefuchaxun",
			name: "kefuchaxun",
			component: kefuchaxun,
			meta: {
				title: "客服查询"
			}
		},
		{
			path: "kehuziliaoChaXun",
			name: "kehuziliaoChaXun",
			component: kehuziliaoChaXun,
			meta: {
				title: "客户资料查询"
			}
		},
		{
			path: "kehuziliaoweihu",
			name: "kehuziliaoweihu",
			component: kehuziliaoweihu,
			meta: {
				title: "客户资料维护"
			}
		},

		{
			path: "quanxianfenpei",
			name: "quanxianfenpei",
			component: quanxianfenpei,
			meta: {
				title: "管理员权限"
			}
		},
		{
			path: "quanbugongdanchaxun",
			name: "quanbugongdanchaxun",
			component: quanbugongdanchaxun,
			meta: {
				title: "全部工单查询"
			}

		},
		{
			path: "XiaBanHouGD",
			name: "XiaBanHouGD",
			component: XiaBanHouGD,
			meta: {
				title: "下班后工单"
			}
		
		},
		{
			path: "quanbugongdanxq",
			name: "quanbugongdanxq",
			component: quanbugongdanxq,
			meta: {
				title: "全部工单详情"
			}


		},
		{
			path: "statistical",
			name: "statistical",
			component: statistical,
			meta: {
				title: "客服工单统计详情"
			}
		},
		{
			path: "xiugaizhanghaoxinxi",
			name: "xiugaizhanghaoxinxi",
			component: xiugaizhanghaoxinxi,
			meta: {
				title: "修改账号信息"
			}

		},
		{
			path: "xiugaikehuzhanghaoxinxi",
			name: "xiugaikehuzhanghaoxinxi",
			component: xiugaikehuzhanghaoxinxi,
			meta: {
				title: "修改客户账号信息"
			}

		},
		{
			path: "quanxianweihu",
			name: "quanxianweihu",
			component: quanxianweihu,
			meta: {
				title: "权限维护"
			}

		},
		{
			path: "quanxianxinzeng",
			name: "quanxianxinzeng",
			component: quanxianxinzeng,
			meta: {
				title: "权限新增"
			}

		},
		{
			path: "chaxunquanxian",
			name: "chaxunquanxian",
			component: chaxunquanxian,
			meta: {
				title: "查询权限"
			}

		},
		{
			path: "customerRanking",
			name: "customerRanking",
			component: customerRanking,
			meta: {
				title: "客户工单排行"
			}

		},
		{
			path: "kefuyijiegongdan",
			name: "kefuyijiegongdan",
			component: kefuyijiegongdan,
			meta: {
				title: "已接工单"
			}

		},
		{
			path: "kehuyiwanchenggongdan",
			name: "kehuyiwanchenggongdan",
			component: kehuyiwanchenggongdan,
			meta: {
				title: "已完成工单"
			}

		},
		{
			path: "zidianweihu",
			name: "zidianweihu",
			component: zidianweihu,
			meta: {
				title: "字典维护"
			}

		},
		{
			path: "zidianxinzeng",
			name: "zidianxinzeng",
			component: zidianxinzeng,
			meta: {
				title: "字典新增"
			}

		},
		{
			path: "zidianxiugai",
			name: "zidianxiugai",
			component: zidianxiugai,
			meta: {
				title: "字典修改"
			}

		},
		{
			path: "kehuxinjiangongdan",
			name: "kehuxinjiangongdan",
			component: kehuxinjiangongdan,
			meta: {
				title: "客户新建工单"
			}

		},
		{
			path: "kehugongdanxiangqing",
			name: "kehugongdanxiangqing",
			component: kehugongdanxiangqing,
			meta: {
				title: "客户工单详情"
			}

		},
		{
			path: "khquanbugongdanxq",
			name: "khquanbugongdanxq",
			component: khquanbugongdanxq,
			meta: {
				title: "客户全部工单详情"
			}

		}, {
			path: "khquanbugongdanchaxun",
			name: "khquanbugongdanchaxun",
			component: khquanbugongdanchaxun,
			meta: {
				title: "客户全部工单"
			}

		}, {
			path: "tuisong",
			name: "tuisong",
			component: tuisong,
			meta: {
				title: "推送"
			}

		},
		{
			path: "kefuyipingjiagongdan",
			name: "kefuyipingjiagongdan",
			component: kefuyipingjiagongdan,
			meta: {
				title: "客服已评价工单"
			}

		},
		{
			path: "shangchuanshipin",
			name: "shangchuanshipin",
			component: shangchuanshipin,
			meta: {
				title: "客服已评价工单"
			}

		},
		{
			path: "mobanchaxun",
			name: "mobanchaxun",
			component: mobanchaxun,
			meta: {
				title: "模版查询"
			}

		},
		{
			path: "mobanchakan",
			name: "mobanchakan",
			component: mobanchakan,
			meta: {
				title: "模版查看"
			}

		},
		{
			path: "kehuzhanwei",
			name: "kehuzhanwei",
			component: kehuzhanwei,
			meta: {
				title: "编辑"
			}

		},
		{
			path: "shishishenqing",
			name: "shishishenqing",
			component: shishishenqing,
			meta: {
				title: "实施申请"
			}

		},
		{
			path: "shishishenqingtianjia",
			name: "shishishenqingtianjia",
			component: shishishenqingtianjia,
			meta: {
				title: "实施申请添加"
			}

		},
		{
			path: "canyusssqlb",
			name: "canyusssqlb",
			component: canyusssqlb,
			meta: {
				title: "参与实施申请列表"
			}

		},
		{
			path: "faqisssqlb",
			name: "faqisssqlb",
			component: faqisssqlb,
			meta: {
				title: "发起实施申请列表"
			}

		},
		{
			path: "qubusssqlb",
			name: "qubusssqlb",
			component: qubusssqlb,
			meta: {
				title: "全部实施申请列表"
			}

		},
		{
			path: "shishishenqingxq",
			name: "shishishenqingxq",
			component: shishishenqingxq,
			meta: {
				title: "实施申请查看"
			}

		},
		{
			path: "shishishenqingbianji",
			name: "shishishenqingbianji",
			component: shishishenqingbianji,
			meta: {
				title: "实施申请编辑"
			}

		},
		{
			path: "WJDC",
			name: "WJDC",
			component: WJDC,
			meta: {
				title: "问卷调查"
			}
		
		},
		{
			path: "liuyan",
			name: "liuyan",
			component: liuyan,
			meta: {
				title: "留言板"
			}
		
		},
		
		






	]
}]

const router = new VueRouter({
	routes,
	mode: "hash"
});

//获取该权限数据

//全局路由守卫前置钩子
router.beforeEach((to, from, next) => {
	let vm = null
	for (let i = 0; i < to.matched.length; i++) {
		let item = to.matched[i]
		if (item.path == to.path) {
			vm = item.instances.default
			break;
		}
	}
	if (vm) {
		vm.updata && vm.updata()
	}
	document.title = to.meta.title; //修改标题
	if (to.path == '/login') { //如果是登录直接跳转
		next();
		return;
	}

	//1、判断是否存在loginTime
	let loginTime = localStorage.getItem('loginTime');
	if (!loginTime) {
		Message({
			title: '提示',
			type: "warning",
			message: '请先登录!'
		});
		next({
			path: '/login'
		})
		return;
	}

	next();
});


router.beforeEach((to, from, next) => {
	//修改标题
	//从from跳转到to里面去
	//to：表示当前路由，meta实在路由映射中配置的静态资源
	//如果以上述方式修改title的话，有嵌套其他组件的组件将会显示不正常
	// document.title = to.matched[0].meta.title;
	let vm = null
	for (let i = 0; i < to.matched.length; i++) {
		let item = to.matched[i]
		if (item.path == to.path) {
			vm = item.instances.default
			break;
		}
	}
	if (vm) {
		vm.updata && vm.updata()
	}

	// 路由拦截
	if (to.path == '/login') { //如果是登录直接跳转
		next();
		document.title = to.meta.title;
	} else { //判断是否有token
		let token = localStorage.getItem('Token');
		if (token) { //判断是否有权限
			if (store.state.limitPath.indexOf(to.name) != -1 || to.name == 'weijiekongdan' || to.meta.show) {
				//修改页面的title
				next();
				document.title = to.meta.title;
			} else {
				next();
				document.title = to.meta.title;
				// next('/home/firstPage');
			}
		} else { //没有token跳转到首页
			Message({
				title: '提示',
				type: "warning",
				message: '请先登录'
			});
			next({
				path: '/login',

			})
		}
	}
})

export default router
